// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__1ewSH","gfeWrapper":"CalendarEvent_gfeWrapper__1quD4"};